export default __webpack_public_path__ + "static/media/group-icon-default.8796ac27.svg";